import cache from '@/lib/utils/cache';
import fetch from '@/lib/api/clients/fetchInvestmentAccounts';

export function init(getFromCache, fetch) {
  return (userId, startDate) => (
    getFromCache(
      `${userId}/${startDate}`,
      () => fetch(userId, startDate),
    )
  );
}

export default init(cache(), fetch.execute);
